<app-page-list [aliasList]="aliasList" [title]="title" [subtitle]="subtitle" [description]="description"
	[linkColor]="linkColor"></app-page-list>